import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const followupSlice = createSlice({
  name: "FollowUpReducer",
  initialState: {
    pageNo: 1,
    pageSize: 10,
    searchParam: null,
    isShowFilter: false,
    isAssignToMe: false,
    diallerAssignmentFilter: undefined,
    connectorId: undefined,
    loanType: undefined,
    location: undefined,
    managerHierarchy: undefined,
    filterData: {
      connectorId: undefined,
      loanType: undefined,
      location: undefined,
      managerHierarchy: undefined,
    },
    filterListDetails: {}, //{ "SUB_CONNECTOR": [], "CONNECTOR": [], "SALES_EXECUTIVE": [], "TEAM_LEADER": [], "SALES_MANAGER": [], "UNIT_MANAGER": [], "REGIONAL_HEAD": [] },
    selectedFilterListDetails: {}, //{ "SUB_CONNECTOR": "", "CONNECTOR": "", "SALES_EXECUTIVE": "", "TEAM_LEADER": "", "SALES_MANAGER": "", "UNIT_MANAGER": "", "REGIONAL_HEAD": "" }
  },
  reducers: {
    setFollowUpPageNo: (state, action: PayloadAction<number>) => {
      state.pageNo = action.payload;
    },
    setFollowUpPageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload;
    },
    setFollowUpSearchParam: (state, action: PayloadAction<any>) => {
      state.searchParam = action.payload;
    },
    setFollowUpIsShowFilter: (state, action: PayloadAction<boolean>) => {
      state.isShowFilter = action.payload;
    },
    setFollowUpIsAssignToMe: (state, action: PayloadAction<boolean>) => {
      state.isAssignToMe = action.payload;
    },
    setFollowUpDiallerAssignmentFilter: (state, action: PayloadAction<any>) => {
        state.diallerAssignmentFilter = action.payload;
      },
    setFollowUpConnectorId: (state, action: PayloadAction<any>) => {
      state.connectorId = action.payload ? action.payload : undefined;
    },
    setFollowUpLoanType: (state, action: PayloadAction<any>) => {
      state.loanType = action.payload ? action.payload : undefined;
    },
    setFollowUpLocation: (state, action: PayloadAction<any>) => {
      state.location = action.payload ? action.payload : undefined;
    },
    setFollowUpManagerHierarchy: (state, action: PayloadAction<any>) => {
      state.managerHierarchy = action.payload ? action.payload : undefined;
    },
    setFollowUpRestFilterData: (state) => {
      state.filterListDetails = {};
      state.selectedFilterListDetails = {};
      state.connectorId = undefined;
      state.loanType = undefined;
      state.location = undefined;
      state.managerHierarchy = undefined;
      state.filterData = {
        connectorId: state.connectorId,
        loanType: state.loanType,
        location: state.location,
        managerHierarchy: state.managerHierarchy,
      };
    },
    setFollowUpFilterData: (state, action: PayloadAction<any>) => {
      state.filterData = action.payload;
    },
    setFollowUpFilterListDetails: (state, action: PayloadAction<any>) => {
      state.filterListDetails[action.payload.key] = action.payload.value;
    },
    setFollowUpSelectedFilterListDetails: (state, action: PayloadAction<any>) => {
      state.selectedFilterListDetails[action.payload.key] =
        action.payload.value;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setFollowUpPageNo,
  setFollowUpPageSize,
  setFollowUpSearchParam,
  setFollowUpIsShowFilter,
  setFollowUpIsAssignToMe,
  setFollowUpDiallerAssignmentFilter,
  setFollowUpConnectorId,
  setFollowUpLoanType,
  setFollowUpLocation,
  setFollowUpManagerHierarchy,
  setFollowUpRestFilterData,
  setFollowUpFilterData,
  setFollowUpFilterListDetails,
  setFollowUpSelectedFilterListDetails,
} = followupSlice.actions;
// You must export the reducer as follows for it to be able to be read by the store.
export default followupSlice.reducer;